export default "__VITE_ASSET__Pt$qLISI__"